import React from 'react';
import { Link } from 'react-router-dom';
import CompanyDetailsBlock from '../components/CompanyDetailsBlock';

const Section = ({ title, children }) => (
  <section>
    <h2
      className="text-xl font-semibold text-[#112318] mb-3"
      style={{ fontFamily: 'Playfair Display, serif' }}
    >
      {title}
    </h2>
    <div className="leading-relaxed space-y-3">{children}</div>
  </section>
);

const CookiePolicyPage = () => (
  <div className="min-h-screen bg-[#FAFAF7]">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="cookie-policy-page">
      <h1
        className="text-4xl sm:text-5xl tracking-tight leading-none font-bold text-[#112318] mb-4"
        style={{ fontFamily: 'Playfair Display, serif' }}
      >
        Cookie Policy
      </h1>
      <p className="text-sm text-[#4A5D50] mb-12">Effective Date: May 2026</p>

      <div className="prose prose-sm max-w-none space-y-10 text-[#4A5D50]">
        <Section title="1. What Are Cookies?">
          <p>
            Cookies are small text files that a website stores on your device. We use them to
            keep you signed in, remember your preferences, and understand how VinePass is used so
            we can improve it.
          </p>
        </Section>

        <Section title="2. Essential Cookies">
          <p>
            Essential cookies are required for the website to function. These cannot be disabled
            without breaking core functionality such as login and checkout.
          </p>
        </Section>

        <Section title="3. Login &amp; Session Cookies">
          <p>
            Once signed in, VinePass sets HTTP-only authentication cookies (<code>access_token</code> and{' '}
            <code>refresh_token</code>) so you stay logged in across pages without re-entering your
            credentials. These cookies are set with the <em>Secure</em> and <em>SameSite</em> flags
            and are not accessible from JavaScript.
          </p>
        </Section>

        <Section title="4. Analytics Cookies">
          <p>
            VinePass uses{' '}
            <a href="https://plausible.io" target="_blank" rel="noreferrer noopener" className="text-[#1F3D2B] underline">
              Plausible Analytics
            </a>{' '}
            — a privacy-friendly analytics service that does not use cross-site tracking cookies
            and does not collect personal data. We collect aggregate metrics (page views, browser,
            device type) to understand which experiences resonate with our visitors.
          </p>
        </Section>

        <Section title="5. Plausible Analytics Tracking">
          <p>
            Plausible does not use third-party cookies, does not fingerprint visitors, and is
            compliant with the GDPR, ePrivacy Directive and South Africa&apos;s POPI Act. No data
            is sold or shared with advertisers.
          </p>
        </Section>

        <Section title="6. How to Manage Cookies">
          <p>
            You can control or delete cookies through your browser settings. Note that disabling
            authentication cookies will sign you out and prevent checkout completion. We do not
            use marketing cookies; there is nothing tracking you across other websites.
          </p>
        </Section>

        <Section title="7. Questions">
          <p>
            For any cookie-related question, email{' '}
            <a href="mailto:info@vinepass.co.za" className="text-[#1F3D2B] underline">info@vinepass.co.za</a>.
          </p>
        </Section>

        <CompanyDetailsBlock />
      </div>

      <div className="mt-16 pt-8 border-t border-[#E5E9E6] flex items-center justify-between">
        <Link to="/privacy" className="text-[#1F3D2B] font-semibold hover:underline text-sm" data-testid="cookie-to-privacy">
          &larr; Privacy Policy
        </Link>
        <Link to="/" className="text-[#1F3D2B] font-semibold hover:underline text-sm" data-testid="cookie-back-home">
          Back to Home &rarr;
        </Link>
      </div>
    </div>
  </div>
);

export default CookiePolicyPage;
